import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import CheckBoxMC from "../../../../../components/CheckBoxMC";

const ItemsTableHeader = ({
  selectedAllProducts,
  selectAllProducts
}) => {
  const { t } = useTranslation('Orders');

  return (
    <div className="tw-grid tw-grid-cols-[40px_minmax(230px,1fr)_140px_160px_repeat(2,140px)_minmax(140px,auto)] tw-items-center tw-border-b tw-text-gray-600 tw-text-sm">
      <div className="tw-pl-4 tw-py-2.5">
        <CheckBoxMC
          checked={selectedAllProducts}
          onChange={selectAllProducts}
          className="tw-w-3 tw-h-3"
        />
      </div>
      <div className="tw-p-4">{t('itemsBox.product')}</div>
      <div className="tw-text-right tw-p-4">{t('itemsBox.quantity')}</div>
      <div className="tw-text-right tw-p-4">{t('itemsBox.unitPrice')}</div>
      <div className="tw-p-4">{t('itemsBox.tax')}</div>
      <div className="tw-text-right tw-p-4">{t('itemsBox.total')}</div>
      <div className="tw-text-right tw-p-4">{t('itemsBox.actions')}</div>

    </div>
  );
};

export default memo(ItemsTableHeader);
